import { supabase } from '@/lib/supabase';

export type AuditModule = 'Proyectos' | 'Facturación' | 'Finanzas' | 'Usuarios' | 'Sistema';

export interface AuditInput {
  userId: string | null;
  userName: string;
  action: string;
  module: AuditModule;
  recordId?: string | null;
  description?: string | null;
}

/**
 * Registra una acción importante en la bitácora de auditoría.
 * Nunca interrumpe la operación principal si falla.
 */
export async function logAudit(input: AuditInput): Promise<void> {
  try {
    await supabase.from('audit_logs').insert({
      user_id: input.userId,
      user_name: input.userName,
      action: input.action,
      module: input.module,
      record_id: input.recordId ?? null,
      description: input.description ?? null,
    });
  } catch {
    // La auditoría no debe bloquear la acción del usuario.
  }
}